import conf from '../../config.json';

export const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
}

//Debug log with classname and message/object
export const logD = (name, obj) => {
    if(conf.debug) {
        console.log(name);
        console.log(obj);
    }
}

function sendError(error) {
    console.error(error.url);
    fetch(conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/error', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({"name": conf.name,
                              "version":conf.version,
                              "host":conf.host,
                              "port":conf.port,
                              "context":conf.context,
                              "error":error.url ? error.url + " " + error.status + " " + error.statusText : JSON.stringify(error),
                            }),
    })
    .then((response) => response.json());
}

//Debug log with classname and message/object
export const logE = (error, summary) => {
    if(conf.error) {
        console.error(error);
        console.error(summary);
        if(error.stack) {
            sendError(error.stack);
            console.log("error.stack");
        }
        else
            sendError(error);
    }
}

export const generateKey = (value) => {
    return window.btoa(value + "_" + Date.now());
}

export const goToWebCitric = (lang) => {
    if(lang === 'es') {
        window.open("https://www.citricdata.com", '_blank');
    } else {
        window.open("https://www.citricdata.com/en/home", '_blank');
    }
}

export function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hours = d.getHours(),
        minutes = d.getMinutes();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    if (hours.length < 2) 
        hours = '0' + hours;
    if (minutes.length < 2) 
        minutes = '0' + minutes;

    return [year, month, day].join('') + '_' + hours + minutes;
}

export default function Util() {

}